<template>
  <div>
    <p v-show="error.show">
      {{ error.txt }}
    </p>
    <ul class="feature__pills list-unstyled m-0 p-0">
      <li
        v-for="tag in state"
        :key="tag.name"
        @click="click(tag.name)"
        :class="{'feature__pills-pill': true, [tag.state]: true, 'disabled': $props.disabled}"
        :title="tag.label"
      >
        {{ tag.label }}
      </li>
    </ul>
  </div>
</template>

<script>
import { makeFeatureRule, RuleKeyAdd, RuleKeyRemove } from './rules/feature';
import { RuleScopeProperty } from './consts';

export default {
    data: () => ( {
        state: {},
        error: {
            show: false,
            txt: ''
        }
    } ),
    methods: {
        click( featureName ) {
            this.error.show = false;

            const feature = this.state[ featureName ];
            const existing = this.$props.tags.includes( featureName );

            if ( existing ) {
                switch ( feature.state ) {
                case 'selected':
                    feature.state = RuleKeyAdd;
                    break;
                case RuleKeyAdd:
                    feature.state = RuleKeyRemove;
                    break;
                case RuleKeyRemove:
                    feature.state = 'selected';
                    break;
                }
            } else {
                switch ( feature.state ) {
                case RuleKeyRemove:
                    feature.state = 'deselect';
                    break;
                case RuleKeyAdd:
                    feature.state = RuleKeyRemove;
                    break;
                case 'deselect':
                    feature.state = RuleKeyAdd;
                    break;
                }
            }

            this.state[ featureName ] = feature;
            this.$emit( 'input', this.stateToRules() );
        },
        stateToRules() {
            const rules = [];

            for ( const featureName in this.state ) {
                let feature = this.state[ featureName ];

                if ( feature.state === 'selected' || feature.state === 'deselect' ) {
                    continue;
                }

                const result = makeFeatureRule( {
                    feature: feature.name,
                    key: feature.state,
                    createdBy: this.$store.getters.email,
                    scope: RuleScopeProperty
                } );

                if ( result.error !== null ) {
                    this.error.txt = result.error.toString();
                    this.error.show = true;
                    return;
                }

                rules.push( result.rule );
            }

            return rules;
        }
    },
    created() {
        const state = {};

        this.$store.getters.propertyFeatures.forEach( tag => {
            state[ tag.name ] = {
                label: tag.labels[ 'en' ],
                name: tag.name,
                state: 'deselect',
                initial: 'deselect'
            };
        } );

        this.$props.tags.forEach( tag => {
            if ( !state.hasOwnProperty( tag ) ) {
                return;
            }
            state[ tag ].state = 'selected';
            state[ tag ].initial = 'selected';
        } );

        this.$props.value.forEach( rule => {
            state[ rule.feature ].state = rule.key;
            state[ rule.feature ].initial = rule.key;
        } );

        this.state = state;
    },
    watch: {
        value: {
            handler() {
                this.$store.getters.propertyFeatures.forEach( tag => {
                    const rule = this.$props.value.find( rule => rule.feature === tag.name );

                    if ( !rule ) {
                        const wasOriginal = this.$props.tags.includes( tag.name );
                        if ( wasOriginal ) {
                            this.state[ tag.name ].state = 'selected';
                            this.state[ tag.name ].initial = 'selected';
                        } else {
                            this.state[ tag.name ].state = 'deselect';
                            this.state[ tag.name ].initial = 'deselect';
                        }
                    } else {
                        this.state[ tag.name ].state = rule.key;
                    }
                } );
            }
        }
    },
    props: {
        tags: {
            type: Array,
            required: true,
            default: () => []
        },
        value: {
            type: Array,
            required: true,
            default: () => []
        },
        disabled: {
            required: true,
            type: Boolean,
            default: () => false
        }
    }
};
</script>

<style scoped>
.feature__pills {
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    padding: 0 20px 20px 0;
}

.feature__pills-pill {
    display: inline-flex;
    margin-right: 2px;
    transition: all 0.2s;
    box-shadow: none !important;
    display: inline-block;
    background-color: rgba(255, 255, 255, 0.9);
    border: 2px solid rgba(139, 139, 139, 0.3);
    color: #adadad;
    border-radius: 25px;
    white-space: nowrap;
    margin: 3px 0px;
    user-select: none;
    transition: all 0.2s;
    padding: 4px 8px;
    cursor: pointer;
    margin-right: 2px;
    font-size: 14px;
}

.selected {
    border: 2px solid rgb(67, 146, 206, 0.3);
    background-color: rgb(67, 146, 206, 0.3);
    color: #333;
}

.feature-add {
    border: 2px solid rgb(0, 159, 0, 0.3);
    background-color: rgb(0, 159, 0, 0.3);
    color: #333;
}

.feature-remove {
    border: 2px solid rgba(220, 53, 69, 0.3);
    background-color: rgba(220, 53, 69, 0.3);
    color: #333;
}
</style>



// WEBPACK FOOTER //
// src/components/property-qc/TagPills.vue